import { useQuery } from "react-query";
import { fetchToolsPages } from "./toolsData";

const endpoints = {
  products: "admin/get-tools-list",
  orders: "admin/get-tools-orders",
  payments: "admin/tools-transactions",
};
export default function useToolsData(type) {
  return useQuery(["tools-market", type], () => fetchToolsPages(endpoints[type]), {
    staleTime: 60000,
    retry: 1,
    refetchOnWindowFocus: true,
  });
}
